// src/components/Login.js
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button, Container, Spinner, Alert } from "react-bootstrap";
import { UserContext } from "../context/UserContext";

const Login = () => {
  const { login, loading, authError } = useContext(UserContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await login(formData);
    if (success) {
      navigate("/dashboard");
    }
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div style={{ width: "100%", maxWidth: "420px" }}>
        <h2 className="mb-4 text-center">Log in</h2>

        {authError && (
          <Alert variant="danger" className="mb-3">
            {authError}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </Form.Group>

          <Button type="submit" className="w-100" disabled={loading}>
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Signing in...
              </>
            ) : (
              "Login"
            )}
          </Button>

          {/* Optional links */}
          {/* 
          <div className="text-center mt-3">
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
          */}
        </Form>
      </div>
    </Container>
  );
};

export default Login;
